module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPane) ? _c('main', {
    class: ['pane-preview-container']
  }, [_c('pane-order-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-package-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-item-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-instance-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-user-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ed1462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/PanePreviewContainer.vue
// module id = 439
// module chunks = 1